import { IAutoRelationship } from '../../interfaces/iauto-relationship';
import { Area } from '../area';
import { Scenario } from '../scenario';
import { TargetFormation } from '../target-formation';

export class AutoRelationshipBase {
  AutoRelationshipId: number;
  ScenarioId: number;
  AreaId: number;
  PrecedingFracGroupTargetFormationId: number;
  SucceedingFracGroupTargetFormationId: number | null;
  Lag: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  Scenario?: Scenario;
  PrecedingFracGroupTargetFormation?: TargetFormation;
  SucceedingFracGroupTargetFormation?: TargetFormation;

  constructor(item?: IAutoRelationship) {
    if (item) {

      this.AutoRelationshipId = item.AutoRelationshipId;
      this.ScenarioId = item.ScenarioId;
      this.AreaId = item.AreaId;
      this.PrecedingFracGroupTargetFormationId = item.PrecedingFracGroupTargetFormationId;
      this.SucceedingFracGroupTargetFormationId = item.SucceedingFracGroupTargetFormationId;
      this.Lag = item.Lag;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.Scenario = new Scenario(item.Scenario);
      this.PrecedingFracGroupTargetFormation = new TargetFormation(item.PrecedingFracGroupTargetFormation);
      this.SucceedingFracGroupTargetFormation = new TargetFormation(item.SucceedingFracGroupTargetFormation);
    }
  }
}